import Hls from "hls.js";
import {FC, useEffect, useRef} from "react";
import {styled} from "@mui/material/styles";
import Loader from "../../lib/hls/Loader.ts";

type VideoPlayerProps = {
    src: string
}

const Video = styled('video')({
    width: "100%",
    height: "100%"
})

const VideoPlayer: FC<VideoPlayerProps> = ({ src, ...props }) => {
    const videoRef = useRef<HTMLVideoElement | null>(null);

    useEffect(()=>{
        const hls = new Hls({
            loader: Loader
        });

        if (videoRef.current && Hls.isSupported()) {
            hls.loadSource(src);
            hls.attachMedia(videoRef.current)
            hls.on(Hls.Events.ERROR, (err, data) => {
                console.log(err, data)
                throw `HLS error: ${err}: ${JSON.stringify(data)}`
            });
        }
    },[src])

    return <Video ref={videoRef} controls {...props} />
}

export default VideoPlayer
